import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LoginPage } from "./pages/login/LoginPage";
import { ForgottenPassword } from "./pages/login/ForgottenPassword";
import { PasswordPage } from "./pages/login/PasswordPage";

export enum ELoginRoutes {
  login = "/",
  forgottenPassword = "/forgottenPasword",
}

export const LoginRouter = () => {
  return (
    <Switch>
      <Route path={`${ELoginRoutes.login}`} component={LoginPage} exact={true} />
      <Route path={`${ELoginRoutes.forgottenPassword}`} component={ForgottenPassword} />
      <Redirect to={`${ELoginRoutes.login}`} />
    </Switch>
  );
};
